module.exports = __webpack_public_path__ + "img/avatar3.41dc3735.png";